import React from "react";
import { FIELDSSET_TITLE_CLASSES } from "features/MappingEditor/consts";
import { useComplianceInfo } from "hooks/useComplianceInfo";
import { useTranslation } from "react-i18next";
import {
  ComponentDetailsByFileOut,
  InventoryProductDetailsByFileOut,
} from "api-client";

const ComplianceInformation = ({
  details,
}: {
  details:
    | InventoryProductDetailsByFileOut
    | ComponentDetailsByFileOut
    | undefined;
}) => {
  const { t } = useTranslation();
  const { getCertificationChipsGroup, getConformityChipsGroup } =
    useComplianceInfo();

  return (
    <div className="border-b border-gray-200 py-4">
      <div className={FIELDSSET_TITLE_CLASSES}>{t("mapping.conformity")}</div>
      <div className="text-sm font-medium mb-2 text-gray-600">
        {t("mapping.certification_desc")}
      </div>
      <div className="mb-3 flex">
        {getCertificationChipsGroup(details?.compliance?.certifications)}
      </div>
      <div className="text-sm font-medium mb-2 text-gray-600">
        {t("mapping.conformity_desc")}
      </div>
      <div className="flex">
        {getConformityChipsGroup(details?.compliance?.conformities)}
      </div>
    </div>
  );
};

export default ComplianceInformation;
